import React from 'react'
import './AppHeader.css'

const AppHeader = ({ children }) => <div className="AppHeader">{children}</div>

export default AppHeader
